// extracted by mini-css-extract-plugin
export default {"modal":"LoadErrorModal_modal__Rx+A5","card":"LoadErrorModal_card__YiAq+"};